import { call, put, takeLatest } from 'redux-saga/effects';
import isBefore from 'date-fns/isBefore';
import subDays from 'date-fns/subDays';
import {
  SUBMIT_USERPERSONA_MODAL,
  DISMISS_USERPERSONA_MODAL,
  showUserpersonaModal
} from 'JS/actionCreators/marketingActions';
import { AUTH_SUCCESS } from 'JS/actionCreators/authActions';
import { DOWNLOAD_REQUEST } from 'JS/actionCreators/downloadActions';
import { HIDE_MODAL } from 'JS/actionCreators/uiActions';
import { EDITOR_CLOSED } from 'JS/actionCreators/editorActions';
import { trackPersonaAnswers } from 'JS/actionCreators/trackingActions';
import getOptimizelyInstance from 'JS/shared/helpers/optmizely';
import { USER_PERSONA_MODAL } from 'JS/config/featureKeys';
import { appServices } from 'JS/shared/helpers/app-services/AppServices';
import { usersnapSurveyInit, usersnapSurveyOpen } from 'JS/shared/helpers/usersnap';
import config from 'JS/config/config';

function* fetchUserpersonaResponse() {
  let userDetails = {};
  try {
    userDetails = yield appServices.getAppData('userpersona');
  } catch (error) {
    if (error.httpStatusCode !== 404) {
      userDetails = { error: true };
    }
  }
  return userDetails;
}

function* saveUserpersonaResponse(userpersonaResponse) {
  try {
    yield appServices.setAppData('userpersona', userpersonaResponse);
  } catch (error) {
    yield;
  }
}

function* saveUserpersonaDismissal() {
  yield saveUserpersonaResponse({
    dismissDate: new Date()
  });
}

function* saveAnswers({ answers }) {
  const answerDate = new Date();
  yield call(saveUserpersonaResponse, {
    answers,
    answerDate
  });
  yield put(trackPersonaAnswers(answers, answerDate, true));
}

export function* initUserpersona() {
  const optimizely = getOptimizelyInstance();
  if (!optimizely.isFeatureEnabled(USER_PERSONA_MODAL)) {
    return;
  }
  const { dismissDate, answerDate, error, answers } = yield fetchUserpersonaResponse();

  if (!error && !answerDate && (!dismissDate || isBefore(new Date(dismissDate), subDays(Date.now(), 7)))) {
    yield put(showUserpersonaModal());
  }
  if (answers) {
    yield put(trackPersonaAnswers(answers, answerDate));
  }
}

async function getSurveyEvents() {
  let surveyEvents = {
    surveyEvents: []
  };
  try {
    surveyEvents = await appServices.getAppData('usersnapsurvey');
  } catch (error) {
    if (error.httpStatusCode !== 404) {
      return { surveyEvents: null };
    }
  }
  return surveyEvents;
}

export function* showUsersnapSurvey() {
  const { surveyEvents } = yield getSurveyEvents();
  if (!Array.isArray(surveyEvents)) {
    return;
  }
  if (surveyEvents.includes('submit')) {
    return;
  }
  if (surveyEvents.length > 1) {
    return;
  }
  yield usersnapSurveyOpen();
}

export function* showIfUpgradeModalDismissed({ modal }) {
  if (modal !== 'UPGRADE') {
    return;
  }
  yield showUsersnapSurvey();
}

const onSubmitOrCloseSurvey = async eventType => {
  if (!['submit', 'dismiss'].includes(eventType)) {
    return;
  }

  const { surveyEvents } = await getSurveyEvents();
  if (!surveyEvents) {
    return;
  }

  await appServices.setAppData('usersnapsurvey', {
    surveyEvents: [...surveyEvents, eventType]
  });
};

export function* initUsersnapSurvey() {
  yield usersnapSurveyInit(config.USERSNAP_SURVEY_KEY, onSubmitOrCloseSurvey);
}

function* marketingSagas() {
  yield takeLatest(AUTH_SUCCESS, initUserpersona);
  yield takeLatest(DISMISS_USERPERSONA_MODAL, saveUserpersonaDismissal);
  yield takeLatest(SUBMIT_USERPERSONA_MODAL, saveAnswers);

  yield takeLatest(AUTH_SUCCESS, initUsersnapSurvey);
  yield takeLatest(HIDE_MODAL, showIfUpgradeModalDismissed);
  yield takeLatest(DOWNLOAD_REQUEST, showUsersnapSurvey);
  yield takeLatest(EDITOR_CLOSED, showUsersnapSurvey);
}

export default marketingSagas;
